module.exports = __webpack_public_path__ + "img/icon_map_blue.dce128a0.svg";